import angular from 'angular';
import insuranceSummaryOfCoverModal from './insuranceSummaryOfCoverModal';

export default angular.module('insuranceSummaryOfCover.scenes', [
  insuranceSummaryOfCoverModal,
]).name;
